<template>
  <div>
    <div class="loader_backdrop"></div>
    <div class="loader_indicator d-flex justify-center align-center">
      <v-progress-circular indeterminate color="primary"></v-progress-circular>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Loader',
};
</script>

<style scoped>
.h-100 {
  height: 100%;
}

.loader_backdrop {
  position: absolute;
  background-color: white;
  opacity: 0.65;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 100;
}

.loader_indicator {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 200;
}
</style>
